import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function PlanSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Plan"
      description="Current plan tier, seat count, feature comparison. Deferred to Phase 2 (pricing tiers)."
    />
  );
}
